export default __webpack_public_path__ + "static/media/first-strip.14aefeca.png";